/*  创建：唐国庆
 *  时间：2021-11-1
 *  功能：Vue组件初始化封装，main中通 use 引用
 */
import zlDialogComponent from './BasicDialog'
import zlSelectComponent from './BasicSelect'

const BasicComponent = {
	install(Vue) {
		Vue.component('BasicDialog', zlDialogComponent)
		Vue.component('BasicSelect', zlSelectComponent)
	}
}
export default BasicComponent